'use strict';

var AMSContentType = /** @class */ (function () {
    function AMSContentType() {
    }
    AMSContentType.isContentPremium = function (item) {
        return item.not_free && item.products && item.products.length;
    };
    AMSContentType.isContentFreemium = function (item) {
        if (AMSContentType.isContentPremium(item)) {
            return false;
        }
        return item.classes && item.classes.length && item.offers && item.offers.length;
    };
    return AMSContentType;
}());

module.exports = AMSContentType;
